module.exports = __webpack_public_path__ + "media/images/Amsale-Flagship-Appt-c6871830.webp";